import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { with_fund_request} from "../../features/userSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIndianRupeeSign,faWallet } from "@fortawesome/free-solid-svg-icons";
import IconWithRoundedBorder from "../borderCir/BoderCir";
const Withdrawal = () => {
  const [amount, setAmount] = useState("");
  const { Info } = useSelector((state) => state.users);
   const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();
    let data = new FormData();
    data.append('phone_number',Info?.phone_number);
    data.append('amount', amount);
    data.append('remark','BANK_TRANSFER');
    data.append('request_number','');
    dispatch(with_fund_request(data));
  };



  return (
    <div className="all_bids" style={{padding:'4%'}}>

<div className="child_comp" style={{height:'78px',borderRadius:'9px',boxShadow:'#e0e0e0 5px 5px 5px'}}><IconWithRoundedBorder boxColor={'#BDBDBD'} innerColor={'white'} outerColor={'white'} FonCompo={<FontAwesomeIcon icon={faWallet} color="#007bff" size='2x'/>}/>
                <div style={{display:'inline-block',marginTop:'3%',marginLeft:'9%'}}>
                    <h3 style={{color:'#007bff'}}><FontAwesomeIcon icon={faIndianRupeeSign} size='1x' color='#007bff'/> {(Info.wallet!=0)?Info.wallet+'.00':Info.wallet}</h3>
                    <p style={{color:'gray'}}>Total Wallet Balance</p>
                </div>
                </div><br/><br/><br/><br/>
                <h4 style={{textAlign:'left',padding:'14px'}}>Withdraw Fund</h4>
          <div className="input-group">
                          <i><FontAwesomeIcon icon={faIndianRupeeSign} color="gray" size="1x" padding='3%' /></i>
                          <input placeholder='Enter withdraw points'className="input_lable_deep" type="number" value={amount} onChange={(e)=>setAmount(e.target.value)}  />
            </div><br/>
         
            <button style={{marginLeft:'9%',width:'80%'}} onClick={handleSubmit} className="continue-button">SUBMIT</button>
            <br/><br/><br/>
      </div>
  );
};

export default Withdrawal;
